"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CountriesService = void 0;
class CountriesService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    getApiV1Countries() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/countries',
            errors: {
                400: `Bad Request
                Not Found
                Internal Server Error
                `,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Oops! Internal server error, try later.`,
            },
        });
    }
    getApiV1CountriesDetected({ currentUserIp, }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/countries/detected/{currentUserIp}',
            path: {
                currentUserIp: currentUserIp,
            },
            errors: {
                400: `Bad Request
                Not Found
                Internal Server Error
                `,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Oops! Internal server error, try later.`,
            },
        });
    }
}
exports.CountriesService = CountriesService;
